export const PrivacyPolicyTitleJsonKey = 'privacyPolicy';
export const PrivacyPolicyTitle = 'Privacy Policy';
export const PrivacyPolicyTextJsonKey = 'privacyPolicyText';
export const PrivacyPolicyText = `   <p>Last Revised: September 1, 2025</p>
    <p>We may collect personal information about you that is subject to privacy laws and applicable regulations. This Privacy Policy outlines how we collect, use, share, and protect your personal information when you visit our website, use our software, or otherwise provide us with your Personal
        Information.</p>
    <ol type="A">
        <li><strong>Definitions</strong>
            <ol>
                <li><strong>"Personal Information"</strong>&nbsp; means data that identifies you; identifies a particular individual; refers to personally identifiable information, personal information, or personal data; or identifies, relates to, describes, is reasonable capable of being associated
                    with,
                    or
                    could
                    reasonably be
                    linked,
                    directly or indirectly, with a particular consumer or household.</li>
                <li><strong>"Service Provider"</strong>&nbsp; means a&nbsp; "Service Provider"&nbsp; under the CCPA, a&nbsp; "Processor"&nbsp; under the GDPR and US state privacy laws, or any natural person, legal entity, or other body that operates under a service-provider contract with us to
                    process
                    Personal
                    Information from us
                    under contractual obligations
                    prohibiting the retention, use, or disclosure of Personal Information collected by us for any purpose other than the purpose specified in the contract or any other purpose permitted under any applicable data privacy laws (i.e. a person or entity who processes any Personal
                    Information
                    we
                    collected on behalf of us).</li>
                <li><strong>"Sensitive Personal Information"</strong>&nbsp; means Personal Information that includes your social security, driver's license, state identification card, or passport number; account log-in, financial account, debit card, or credit card number in combination with any
                    required
                    security or
                    access code,
                    password, or credentials allowing access to an account; precise geolocation; racial or ethnic origin, citizenship or immigration status, religious or philosophical beliefs, or union membership; contents of your mail, email, and text messages unless we are the intended recipient
                    of
                    the
                    communication; genetic data; biometric information; Personal Information concerning your health; Personal Information collected and analyzed concerning your sex life, sexuality, or sexual orientation, Personal Information collected from a known child.</li>
            </ol>
            <p></p>
        </li>
        <li><strong>How We Collect Your Personal Information.</strong>
            <p><strong>Directly from you.</strong> We collect your Personal Information directly from you when you provide such information directly to us, for example, when you submit information through a form on our website, send us emails, apply for a job, or use our software.</p>
            <p><strong>Tracking technologies.</strong> When you visit our website or use our mobile app, we or third-parties we work with, automatically collect certain information using online tracking technologies such as pixels, web beacons, software developer kits, third-party libraries, and
                cookies.
            </p>
        </li>
        <li><strong>Personal Information We Collect About You.</strong>
            <p>We may collect and use the following Personal Information:</p>
            <table>
                <tbody>
                    <tr>
                        <td>
                            <strong>
                                <p>Categories of Personal Information</p>
                            </strong>
                        </td>
                        <td>
                            <strong>
                                <p>Specific Types of Personal Information Collected</p>
                            </strong>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Employment Information</p>
                        </td>
                        <td>
                            <p>Information you provide as part of applying for a job or during the course of your employment. </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Identifying Information</p>
                        </td>
                        <td>
                            <p>Name, email address, postal address, phone number, date of birth.</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Technical Information</p>
                        </td>
                        <td>
                            <p>IP address, browser type and version, preferred language, geographic location, operating system and computer platform, services you have viewed or searched for while using our websites, and parts of our websites that you have visited. </p>
                        </td>
                    </tr>
                </tbody>
            </table>
            <p></p>
        </li>
        <li><strong>Why We Use Your Personal Information.</strong>
            <p>In addition to the disclosures above about our use of Tracking Technologies, we collect and use Personal Information for the following purposes:</p>
            <table>
                <tbody>
                    <tr>
                        <td>
                            <strong>
                                <p>Information</p>
                            </strong>
                        </td>
                        <td>
                            <strong>
                                <p>What we use your Personal Information for</p>
                            </strong>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Identifying Information, and Technical Information</p>
                        </td>
                        <td>
                            <ul>
                                <li>To engage in commercial transactions with you;</li>
                                <li>To prevent and detect fraud;</li>
                                <li>Other processing necessary to comply with professional, legal and regulatory obligations that apply to us; </li>
                                <li>Screening for financial and other sanctions or embargoes;</li>
                                <li>Gathering and providing information required by or relating to audits, enquiries or investigations by regulatory bodies; </li>
                                <li>Ensuring business policies are adhered to, e.g. policies covering security and internet use; </li>
                                <li>Operational reasons, such as improving efficiency, training and quality control; </li>
                                <li>Ensuring the confidentiality of commercially sensitive information; </li>
                                <li>Statistical analysis to help us manage our business, e.g. in relation to our financial performance; </li>
                                <li>Preventing unauthorized access and modifications to systems;</li>
                                <li>Ensuring safe working practices and staff administration and assessments; </li>
                                <li>External audits and quality checks, e.g. for accreditation and the audit of our accounts; </li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Employment Information</p>
                        </td>
                        <td>
                            <ul>
                                <li>To assess your eligibility for employment, onboard and enroll you as an employee, evaluate your performance, operate our business, comply with laws, communicate with you, and to provide you with compensation and benefits. </li>
                            </ul>
                        </td>
                    </tr>
                </tbody>
            </table>
            <p></p>
        </li>
        <li><strong>Who We Share Your Personal Information With. We share or disclosed your Personal Information for a business purpose as described below:</strong>
            <ul>
                <li>We share or disclose Personal Information with our service providers to process this data on our behalf in order to help deliver our services to you. For example, we use a third-party software provider to process and store information collected from users of our software.</li>
                <li>We may also disclose and exchange Personal Information with law enforcement agencies and regulatory bodies to comply with our legal and regulatory obligations.</li>
            </ul>
            <p></p>
        </li>
        <li><strong>Personal Information We Sell. We do not sell any Personal Information.</strong>
            <p></p>
        </li>
        <li>
            <strong>How Long Your Personal Information Will Be Kept. </strong>We will keep your Personal Information for the period necessary to fulfill the purposes outlined in this privacy policy, unless a longer retention period is required or permitted by law.

            <strong>
                <p>We will also keep your Personal Information for as long as is necessary:</p>
            </strong>
            <ul>
                <li>To respond to any questions, complaints or claims made by you or on your behalf; </li>
                <li>To show that we treated you fairly; or</li>
                <li>To keep records required by law.</li>
            </ul>
            <p>When it is no longer necessary to retain your Personal Information, we will delete or deidentify it.</p>
        </li>
        <li>
            <strong>Where Your Personal Information is Held.</strong> Information may be held at our offices and those of our Service Providers in the United States.<p></p>
        </li>
        <li><strong>IMPORTANT NOTICE FOR CHILDREN UNDER THE AGE OF SIXTEEN (16).</strong> We do not intentionally collect the Personal Information of individuals under sixteen years of age. <strong>IF YOU ARE UNDER THE AGE OF 16</strong>, your parent or legal guardian must agree to this Policy.
            Also,
            <strong>
                WE WILL NOT RETAIN ANY PERSONAL
                INFORMATION OF ANY PERSON UNDER THE AGE OF THIRTEEN (13) IF KNOWINGLY COLLECTED WITHOUT PARENTAL OR LEGAL GUARDIAN SUPERVISION AND CONSENT.
            </strong> If we learn that we have collected Personal Information from someone under the age of 13 that was not provided with the supervision and consent of the
            minor's parents or legal guardian, we will promptly delete that Personal Information. If you believe we have impermissibly collected Personal Information from someone under the age of 13, please contact us immediately.
            <p></p>
        </li>
        <li>
            <strong> Available Rights to You </strong>
            <p></p>
            <ol>
                <li> <strong>
                        Your Rights in General.
                    </strong>

                    <strong>
                        <p>United State privacy law provides residents with certain rights that may be applicable to you:</p>
                    </strong>

                    <table>
                        <tbody>
                            <tr>
                                <td>
                                    <p>Disclosure of Personal Information We Collect About You</p>
                                </td>
                                <td>
                                    <p>You have the right to know:</p>
                                    <ul>
                                        <li>Whether we are processing your Personal Information;</li>
                                        <li>The categories of Personal Information we have collected about you; </li>
                                        <li>The categories of sources from which the Personal Information is collected; </li>
                                        <li>Our business or commercial purpose for collecting or selling Personal Information; </li>
                                        <li>The categories of third parties with whom we share Personal Information, if any; and </li>
                                        <li>The specific pieces of Personal Information we have collected about you. </li>
                                    </ul>
                                    <p></p>
                                    <p>Please note that we are not required to:</p>
                                    <ul>
                                        <li>Retain any Personal Information about you that was collected for a single one-time transaction if, in the ordinary course of business, that information about you is not retained;</li>
                                        <li>Reidentify or otherwise link any data that, in the ordinary course of business, is not maintained in a manner that would be considered Personal Information; or</li>
                                        <li>Provide the Personal Information collected to you more than twice in a 12-month period.</li>
                                    </ul>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p>Personal Information Sold or Used for a Business Purpose</p>
                                </td>
                                <td>
                                    <p>In connection with any Personal Information we may sell or disclose to a third party for a business purpose, you have the right to know: </p>
                                    <ul>
                                        <li>The categories of Personal Information about you that we sold and the categories of third parties to whom the Personal Information was sold; and </li>
                                        <li>The categories of Personal Information that we disclosed about you for a business purpose. </li>
                                    </ul>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p>Right to Opt-out</p>
                                </td>
                                <td>
                                    <p>You have the right to opt-out of the sale of your Personal Information to third parties or Service Providers, the use for targeted advertising, and profiling in furtherance of a decision that produces a legal or similarly significant effect concerning you. </p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p>Right to Access</p>
                                </td>
                                <td>
                                    <p>The right to be provided with a copy of your Personal Information (the right of access) </p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p>Right to Limit the Use and Disclosure of Sensitive Personal Information. </p>
                                </td>
                                <td>
                                    <p>The right to limit the use and disclosure of any Sensitive Personal Information about you. </p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p>Right to Rectification or Correct Personal Information</p>
                                </td>
                                <td>
                                    <p>The right to require us to correct any mistakes in your Personal Information </p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p>Right to be Forgotten or Deleted</p>
                                </td>
                                <td>
                                    <p>The right to require us to delete your Personal Information</p>
                                    <p></p>
                                    <p>We may deny the request if the information is necessary to:</p>
                                    <ul>
                                        <li>Complete providing a service requested or reasonably anticipated by the Opt-In Participant </li>
                                        <li>Detect and protect against security incidents, malicious, deceptive, fraudulent, or illegal activity, or take action against those responsible for such activity </li>
                                        <li>Debug to identify and repair errors impairing intended functionality </li>
                                        <li>Engage in research in the public interest adhering to applicable ethics and privacy laws where the Opt-In Participant has provided informed consent </li>
                                        <li>Enable solely internal uses reasonably aligned with the Opt-In Participant 's expectations based on the Opt-In Participant 's relationship with us </li>
                                        <li>Comply with any legal proceeding, court order, law, legal investigation, regulatory body, or other legal obligation </li>
                                        <li>Otherwise use the information internally in a lawful manner compatible with the context in which the Opt-In Participant provided the information </li>
                                    </ul>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p>Right to Restriction of Processing</p>
                                </td>
                                <td>
                                    <p>The right to require us to restrict processing of your Personal Information —in certain circumstances, e.g. if you contest the accuracy of the data </p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p>Right to Data Portability</p>
                                </td>
                                <td>
                                    <p>The right to receive the Personal Information you provided to us in a portable and readily usable format. If the Personal Information is in a platform, you may have the right to receive the information in a format that allows the transfer to another platform.
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p>Right to Object</p>
                                </td>
                                <td>
                                    <p>The right to object:</p>
                                    <ul>
                                        <li>At any time to your Personal Information being processed for direct marketing (including profiling) </li>
                                        <li>In certain other situations to our continued processing of your Personal Information, e.g. processing carried out for the purpose of our legitimate interests </li>
                                    </ul>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p>Right Not to Be Subject to Automated Individual Decision-Making</p>
                                </td>
                                <td>
                                    <p>The right not to be subject to a decision based solely on automated processing (including profiling) that produces legal effects concerning you or similarly significantly affects you </p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p>Right Not to Be Discriminated Against</p>
                                </td>
                                <td>
                                    <p>You have the right to not be discriminated against by us because you exercised any of your rights. This means we cannot, among other things: </p>
                                    <ul>
                                        <li>Deny goods or services to you;</li>
                                        <li> Charge different prices or rates for goods or services, including through the use of discounts or other benefits or imposing penalties; </li>
                                        <li> Provide a different level or quality of goods or services to you; or </li>
                                        <li> Suggest that you will receive a different price or rate for goods or services or a different level or quality of goods or services. </li>
                                    </ul>
                                    <p></p>
                                    <p>Please note that we may charge a different price or rate or provide a different level or quality of goods and services to you, if that difference is reasonably related to the value provided to our business by your Personal Information. </p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p>Right to Appeal the Denial of an Enforcement of Your Right by Us</p>
                                </td>
                                <td>
                                    <p>You have the right to appeal the denial or failure to enforce any request of your rights listed above by us. </p>
                                    <p></p>
                                    <p>You can appeal any data privacy decision or indecision we make concerning your Personal Information by emailing us and including the word "Appeal" in the subject line of the email with information sufficient to allow us to identify the original request. </p>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <p></p>
                </li>

                <li> <strong>How to Contact Us or Exercise Your Rights.</strong> If you would like to contact us or exercise any of your rights as described in this Policy, please call us at <a href="tel:+15594532410">(559) 453-2410</a> or email us at <a
                        href="mailto:helpdesk@myworkplace.net">helpdesk@myworkplace.net</a>.
                    <p> Not all of the rights listed above may apply to you depending on your state of residence and other factors, including restrictions on the number of times per year you can make certain kinds of requests. We reserve the right to evaluate your request to determine our
                        responsibilities
                        for
                        complying
                        with the request.</p>
                    <p> If you choose to contact us directly by, you will need to provide us with:</p>
                    <ul>
                        <li> Enough information to identify you (e.g., your full name, email address and phone number); </li>
                        <li> Proof of your identity and address (e.g., a copy of your driving license or passport and a recent utility or credit card bill); and </li>
                        <li> A description of what right you want to exercise and the information to which your request relates. </li>
                    </ul>
                    <p></p>
                    <p> We are not obligated to make a data access or data portability disclosure if we cannot verify that the person making the request is the person about whom we collected information, or is someone authorized to act on such person 's behalf.</p>
                    <p> Any Personal Information we collect from you to verify your identity in connection with you request will be used solely for the purposes of verification.</p>
                </li>
            </ol>
        </li>
        <li> <strong> General Information </strong>
            <ol>
                <li> <strong>Changes to This Privacy Notice.</strong> We may change this Policy from time to time.</li>
                <li> <strong>Do You Need Extra Help?</strong> If you would like this Policy in another format (for example: audio, large print, braille), please contact us (see&nbsp; "How to Contact Us"&nbsp; above).</li>
            </ol>
        </li>
    </ol>`;

export const TermsOfServiceTitleJsonKey = 'termsOfService';
export const TermsOfServiceTitle = 'Terms Of Service';

export const TermsOfServiceTextJsonKey = 'TermsOfServiceText';
export const TermsOfServiceText = `
      <p>
        These Terms of Services ("<strong>Terms</strong>") is entered into between the
        Client and MyWorkplace are incorporated into an agreement between you and
        MyWorkplace. Capitalized words in these Terms shall have the same definition
        as in the Agreement unless otherwise defined herein. These Terms shall control
        in the event of a conflict between these Terms and the Agreement.
    </p>
    <ol>
        <li>
            <strong>Services.</strong> MyWorkplace shall provide Client with access to the Platform as
            identified in the Order (the "<strong>Services</strong>").
            <p></p>
        </li>
        <li><strong>Other Services.</strong>
            <ol type="a">
                <li>
                    <strong>Programming/Technical Services Rate:</strong> $150.00 per hour. At MyWorkplace's
                    sole discretion, MyWorkplace may charge for programming and/or technical
                    services requested by Client. In such cases where a charge will be
                    incurred, MyWorkplace will provide Client with a quote and will require
                    Client's acceptance/approval prior to job implementation. Fifty percent
                    (50%) of quoted rate will be required before programming begins, balance
                    due at completion of project. To the extent that actual work performed
                    costs less than the initial up-front payment, MyWorkplace will rebate the
                    excess funds to Client.
                </li>
                <li>
                    <strong>Benefit Plan Renewal Changes/Bulk Data Changes or Additions:</strong> $100.00 per
                    hour. At MyWorkplace's sole discretion, MyWorkplace may charge for benefit
                    plan renewal changes/data changes or additions requested by Client that
                    will exceed the eight (8) hours of MyWorkplace staff time allowed to
                    client for renewal functions. In such cases where a charge will be
                    incurred, MyWorkplace will provide Client with a quote and will require
                    Client's acceptance/approval prior to job implementation. Fifty percent
                    (50%) of quoted rate will be required before programming begins, balance
                    due at completion of project. To the extent that actual work performed
                    costs less than the initial up-front payment, MyWorkplace will rebate the
                    excess funds to Client.
                </li>
                <li>
                    <strong>Subject to modification.</strong> The rates for Other Services described above may
                    be amended by MyWorkplace upon 90-day notice to Client.
                </li>
            </ol>
            <p></p>
        </li>
        <li><strong>Fees and Expenses.</strong>
            <ol type="a">
                <li>
                    <strong>Fees.</strong> As full consideration for the provision of the Services, Client
                    shall pay MyWorkplace fees set forth in the Order. Client is responsible
                    for paying any sales tax applicable to the Fees.
                </li>
                <li>
                    <strong>Billing and Payment.</strong> MyWorkplace shall prepare and submit an invoice to
                    the Client for the Fees.
                </li>
                <li>
                    <strong>Payment.</strong> Client agrees to pay the Fees. If any amount owing by Client is
                    90 or more days overdue, MyWorkplace may, without limiting its other
                    rights and remedies, suspend Client's access to the Services until such
                    amounts are paid in full.
                </li>
            </ol>
            <p></p>
        </li>
        <li><strong>Confidential Information.</strong>
            <ol type="a">
                <li>
                    As used in this Agreement, "<strong><u>Confidential Information</u></strong>" means all trade
                    secrets, data, information about pricing, forms and types of financial,
                    business, scientific, technical, economic, or engineering information,
                    including patterns, plans, compilations, program devices, formulas,
                    designs, prototypes, methods, techniques, processes, procedures, programs,
                    or codes, whether tangible or intangible, and whether or how stored,
                    compiled, or memorialized physically, electronically, graphically,
                    photographically, or in writing if (A) the disclosing Party has taken
                    reasonable measures to keep such information confidential; and (B) the
                    information derives independent economic value, actual or potential, from
                    not being generally known to, and not being readily ascertainable through
                    proper means by, another person who can obtain economic value from the
                    disclosure or use of the information. Confidential Information shall not
                    include any information which (A) was publicly known prior to the time of
                    disclosure by the disclosing Party, or becomes publicly known after
                    disclosure by the disclosing Party through no action or inaction of the
                    receiving Party in violation of this Agreement; (B) is already in the
                    possession of the receiving Party at the time of disclosure by the
                    disclosing Party; (C) is obtained by the receiving Party from a third
                    party without a breach of such third party 's obligations of
                    confidentiality; or (D) is independently developed by the receiving Party
                    without use of or reference to the disclosing Party 's Confidential
                    Information.
                </li>
                <li>
                    The receiving Party will only use and disclose the disclosing Party's
                    Confidential Information as reasonably necessary to deliver the Software
                    and/or Services. Any other use or disclosure to a third-party is
                    prohibited unless expressly permitted in writing by the disclosing Party.
                    The receiving Party agrees to hold the disclosing Party's Confidential
                    Information in strict confidence and use reasonable measures to protect it
                    as confidential. The receiving Party shall be permitted to disclose
                    Confidential Information to third-parties only to the extent required by
                    law, provided that the receiving Party gives the disclosing Party prompt
                    written notice of such requirement and upon the request of the disclosing
                    Party, the receiving Party cooperates in good faith and at the expense of
                    the disclosing Party in any reasonable and lawful actions which the
                    disclosing Party takes to resist such disclosure or limit the information
                    to be disclosed.
                </li>
                <li>
                    Upon written request by the disclosing Party, the receiving Party will
                    promptly return or destroy all of the disclosing Party's Confidential
                    Information, provided that the receiving Party shall have the right,
                    subject to the requirements of this Agreement, to retain disclosing
                    Party's Confidential Information contained in the receiving Party's (i)
                    professional work papers and (ii) secure, archival computer back-up files
                    maintained in the ordinary course of business. If so requested by the
                    disclosing Party, the receiving Party shall promptly certify to the
                    disclosing Party that all Confidential Information has been returned or
                    destroyed in compliance with this paragraph.
                </li>
            </ol>
            <p></p>
        </li>
        <li><strong>Data</strong>
            <ol type="a">
                <li>
                    <a href="https://www.myworkplace.net/imagesclient/assets/MyWorkplaceDataProcessingAddendum.pdf">The MyWorkplace Data Processing Addendum ("DPA") is currently set forth
                        here</a>. Each party shall comply with its obligations under the DPA, which is
                    hereby incorporated by reference. The terms Client Data, Personal
                    Information, and Client Third Party Provider have the meaning in the DPA.
                </li>
                <li>
                    MyWorkplace hereby acknowledges and agrees that as between MyWorkplace and
                    Client, Client owns all Client Data. Client grants MyWorkplace the right
                    to collect, use and disclose Client Data: (i) to provide, manage,
                    maintain, enhance, optimize, improve, and add to the Services, including
                    providing Client Data to third parties that enable or supplement
                    MyWorkplace 's provision of the Services; (ii) in connection with
                    MyWorkplace's demonstration of or efforts to sell additional Services to
                    Client; (iii) as directed by Client in writing (email acceptable) in
                    connection with Client's use of the Services (including providing Client
                    Data to Client Third Party Providers whose services Client elects to use);
                    and (iv) to enforce MyWorkplace's rights under this Agreement. For
                    clarity, MyWorkplace shall have no liability to Client for the disclosure,
                    use or misuse of Client Data by any Client Third Party Provider.
                </li>
                <li>
                    Notwithstanding anything to the contrary in this Agreement, Client hereby
                    authorizes MyWorkplace to: (i) Anonymize (as defined below) Client Data;
                    and (ii) use such Anonymized Client Data for any legal business purpose,
                    including for distribution to third parties. "Anonymize "means, for any
                    data set, removal of Personal Information and any information reasonably
                    likely to identify a company or other business entity, and aggregation of
                    the anonymized data set with other data, each in a manner such that the
                    Personal Information and such information cannot be restored, deduced or
                    derived.
                </li>
                <li>
                    Notwithstanding anything in this Agreement or otherwise to the contrary,
                    you agree that MyWorkplace will not have any liability for an unauthorized
                    party gaining access to your Confidential Information maintained on the
                    computer systems or records of MyWorkplace or its service providers, so
                    long as commercially reasonable efforts were made to maintain the security
                    of such computer system and records.
                </li>
            </ol>
            <p></p>
        </li>
        <li><strong>Intellectual Property.</strong>
            <ol type="a">
                <li>
                    <strong>License of Platform.</strong> Subject to the terms and conditions of this
                    Agreement, MyWorkplace grants to Client a non-exclusive and
                    non-transferable license to the Platform during the Term.
                </li>
                <li>
                    <strong>Ownership of Preexisting IP.</strong> Both Party's pre-existing intellectual
                    property shall remain the sole and exclusive property of the respective
                    Party.
                </li>
                <li>
                    <strong>Ownership of Platform.</strong> The Platform, including any amendments or
                    modifications thereto, licensed to Client pursuant to this Agreement shall
                    be the sole and exclusive property of MyWorkplace. Client shall not: (i)
                    create derivate works based on the Platform or copy any features,
                    functions or graphics of the Platform, (ii) copy any part or content of
                    the Platform (iii) reverse-engineer the Platform, or (iv) access the
                    Platform in order to (a) build a competitive product or software, or (b)
                    copy any features, functions or graphics of the Platform.
                </li>
                <li>
                    <strong>Client Data.</strong> The Client Data shall be exclusively owned by Client.
                    MyWorkplace shall have the right to process the Client Data solely to
                    provide the Services to Client in accordance with the terms of this
                    Agreement.
                </li>
                <li>
                    <strong>Other Deliverables.</strong> Ownership of any other works created in whole or in
                    part by MyWorkplace and delivered to Client pursuant to this Agreement,
                    including modifications or updates to the Platform, shall be owned
                    exclusively by MyWorkplace.
                </li>
            </ol>
            <p></p>
        </li>
        <li><strong>Warranty.</strong>
            <ol type="a">
                <li>
                    Each party represents to the other that this is a valid and binding
                    Agreement of the party and that nothing in it will place the party in
                    breach of any other agreement. Each party also represents to the other
                    that it will at all times comply with all applicable federal, state and
                    local laws, rules, ordinances, regulations and codes. Each Party warrants
                    and represents that it has the authority to execute, deliver and perform
                    its obligations under this Agreement, and is duly organized or formed and
                    validly existing and in good standing under the laws of the state of its
                    incorporation or formation.
                </li>
            </ol>
            <p></p>
        </li>
        <li><strong>Material Defects.</strong>
            <p>
                MyWorkplace warrants that its Software will be free of any and all material
                defects that make the Software unusable or inoperable and for which no
                reasonable work around exists ("<strong>Material Defects</strong>"). Client shall notify
                MyWorkplace in writing of all material defects within fourteen (14) days of
                discovery by describing the issue and specifically identifying it to
                MyWorkplace as a "Material Defect "pursuant to this section. Any purported
                Material Defect not promptly identified in accordance with this section
                shall not be deemed a Material Defect and MyWorkplace shall not be liable
                for any claim for breach of warranty or breach of this Agreement related to
                said issue. Client's sole and exclusive recourse for any Material Defects
                shall be (1) first, MyWorkplace shall attempt to resolve the Material Defect
                and (2) if the Material Defect is not resolved or MyWorkplace has not
                created a reasonable workaround in fourteen (14) days, Client may terminate
                this Agreement and shall receive a refund of any prepaid amounts for
                Services beyond the termination date. Additionally, if the Platform is not
                available for use by Client more than 98.0% during business hours in any
                given calendar month, Client, at its sole discretion, may request and
                receive a credit of 1% of the total monthly system access fee for each
                subsequent .1% drop below 98.0% in availability of the system, to a maximum
                of 5% of the monthly fee (the "<strong>Service Commitment</strong>"). The Service Commitment
                excludes (i) scheduled maintenance typically performed outside of normal
                business hours, (ii) emergency or unscheduled maintenance of up to 120
                minutes per calendar month, with reasonable advance notice, when possible;
                (iii) events of force majeure which are outside of MyWorkplace's reasonable
                control after taking reasonable precautions consistent with industry
                standards; (iv) any upgrades required by the occurrence of any events
                outside of MyWorkplace's control; and (v) interruptions of third party
                networks that prevent internet users from accessing the Platform,
                interruptions in utility service, the lack of availability of Client as
                necessary to respond to incidents that require their respective
                participation. Normal business hours are defined as Monday through Friday,
                excluding holidays, from 8 am to 8 pm, eastern standard time.
            </p>
            <p>
                EXCEPT AS EXPRESSLY SET FORTH HEREIN, MYWORKPLACE SPECIFICALLY DISCLAIMS ANY
                OTHER REPRESENTATIONS OR WARRANTIES, EXPRESS OR IMPLIED, INCLUDING WITHOUT
                LIMITATION WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE
                AND NON-INFRINGEMENT. <strong>
                    MYWORKPLACE DOES NOT WARRANT THAT THE SOFTWARE OR
                    SERVICES WILL BE ERROR-FREE OR THAT THE SERVICES WILL WORK WITHOUT
                    INTERRUPTIONS.
                </strong>
            </p>
            <p></p>
        </li>
        <li><strong>Termination.</strong>
            <ol type="a">
                <li>
                    <strong>Without Cause.</strong> Either Party may terminate this Agreement without cause
                    effective on thirty (30) days written notice to the other Party.
                </li>
                <li>
                    <strong>For Cause.</strong> Either Party may terminate this Agreement, effective upon
                    written notice to the other party (the "<strong>Defaulting Party</strong>"), if the
                    Defaulting Party materially breaches this Agreement, and such breach is
                    incapable of cure, or with respect to a material breach capable of cure,
                    the Defaulting Party does not cure such breach within ten (10) days after
                    receipt of written notice of such breach.
                </li>
                <li>
                    If Client has ordered the Payroll module and terminates without cause, all
                    remaining fees due for the payroll module through the end of the year
                    shall immediately be due and payable to MyWorkplace. If MyWorkplace
                    terminates without cause or Client terminates due to the material breach
                    of MyWorkplace, MyWorkplace shall, on a pro rata basis, repay all Fees
                    paid in advance for any Services which have not been provided.
                </li>
                <li>
                    If the Agreement is terminated for any reason, (a) Each party shall (i)
                    return to the other party all documents and tangible materials (and any
                    copies) containing, reflecting, incorporating or based on the other party
                    's Confidential Information, (ii) permanently erase all of the other party
                    's Confidential Information from its computer systems and (iii) certify in
                    writing to the other party that it has complied with the requirements of
                    this clause; provided, however, that MyWorkplace may retain Confidential
                    Information in its computer archive and backups or as necessary to comply
                    with legal, financial, or regulatory obligations.
                </li>
            </ol>
            <p></p>
        </li>
        <li>
            <strong>LIMITATIONS OF LIABILITY.</strong> EXCEPT FOR THE PARTIES
            CONFIDENTIALITY OBLIGATIONS, IN NO EVENT SHALL EITHER PARTY BE LIABLE UNDER
            THIS AGREEMENT TO THE OTHER PARTY FOR ANY INCIDENTAL, CONSEQUENTIAL,
            NOMINAL, INDIRECT, STATUTORY, SPECIAL, EXEMPLARY OR PUNITIVE DAMAGES,
            INCLUDING, BUT NOT LIMITED TO, LOST PROFITS, LOSS OF USE, LOSS OF TIME,
            INCONVENIENCE, LOST BUSINESS OPPORTUNITIES, DAMAGE TO GOOD WILL OR
            REPUTATION, AND COSTS OF COVER, REGARDLESS OF WHETHER SUCH LIABILITY IS
            BASED ON BREACH OF CONTRACT, TORT, STRICT LIABILITY OR OTHERWISE, AND EVEN
            IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGES OR SUCH DAMAGES COULD HAVE
            BEEN REASONABLY FORESEEN. SUBJECT TO THE CLIENT'S OBLIGATION TO PAY THE FEES
            TO MYWORKPLACE, EACH PARTY'S ENTIRE AGGREGATE LIABILITY FOR ANY CLAIMS
            RELATING TO THE PLATFORM AND/OR SERVICES AND/OR THIS AGREEMENT, INCLUDING
            ATTORNEY'S FEES, SHALL NOT EXCEED THE FEES PAID OR PAYABLE BY THE CLIENT TO
            MYWORKPLACE UNDER THIS AGREEMENT IN THE TWELVE (12) MONTH PERIOD IMMEDIATELY
            PRECEDING THE EVENTS GIVING RISE TO SUCH LIABILITY. THE LIMITATIONS IN THIS
            PARAGRAPH TO NOT APPLY TO CLIENT'S PAYMENT OBLIGATIONS. THIS SECTION SHALL
            SURVIVE THE TERMINATION OF THE AGREEMENT.
            <p></p>
        </li>
        <li>
            <strong>Indemnification.</strong> Subject to the limitation of liability
            provisions in this Agreement, MyWorkplace shall indemnify, defend and hold
            harmless Client, its employees, and principals (partners, shareholders or
            holders of an ownership interest, as the case may be), from and against any
            third party claims, demands, loss, damage or expense (a "Claim ") that the
            Products infringe the intellectual property of a third party. Client shall
            provide MyWorkplace with prompt written notice of any claim and give
            complete control of the defense and settlement to MyWorkplace, and shall
            cooperate with MyWorkplace, its insurance provider and its legal counsel in
            its defense of such claim(s). This indemnity shall not cover any Claim in
            which there is a failure to give MyWorkplace prompt notice to the extent
            such lack of notice prejudices the defense of the claim. MyWorkplace shall,
            solely at its own cost and expense, obtain for Client the right to continue
            using or selling the Product or MyWorkplace may modify the Product to avoid
            the infringement. If MyWorkplace is unable to obtain for Client the right to
            continue using or selling the Product or to modify the Product to avoid the
            infringement as specified in the previous sentence, MyWorkplace shall
            endeavor to replace the Product with a compatible, functionally equivalent
            replacement that is non-infringing. If none of the foregoing alternatives
            are possible after exerting commercially reasonable efforts, MyWorkplace
            shall fully credit to Client any amounts paid for the allegedly infringing
            Products paid for but not delivered and any allegedly infringing Products
            still remaining in the inventory of Client, whereupon Client shall return
            such Protected Materials to MyWorkplace, or destroy or delete them, at
            MyWorkplace's option.
            <p></p>
        </li>
        <li>
            <strong>Insurance.</strong> MyWorkplace shall maintain insurance coverage in the following
            types and amounts:

            <ol type="a">
                <li>General Liability.</li>
                <ol type="i">
                    <li>Aggregate limit: $2,000,000</li>
                    <li>Each Occurrence Limit: $1,000,000</li>
                    <li>Tech and Telecommunications Liability: $5,000,000</li>
                </ol>

                <li>
                    <strong>Cooperation of Client.</strong> Client agrees to comply with all reasonable
                    requests of MyWorkplace and shall provide MyWorkplace's personnel with
                    access to all documents and facilities as may be reasonably necessary for
                    the performance of this Agreement.
                </li>
            </ol>
            <p></p>
        </li>
        <li>
            <strong>Relationship of the Parties.</strong> The relationship of the Parties hereto is that
            of independent contractors. Nothing in this Agreement, and no course of
            dealing between the Parties, shall be construed to create or imply an
            employment or agency relationship or a partnership or joint venture
            relationship between the Parties or between one Party and the other Party's
            employees or agents. Each of the Parties is an independent contractor and
            neither Party has the authority to bind or contract any obligation in the
            name of or on account of the other Party or to incur any liability or make
            any statements, representations, warranties or commitments on behalf of the
            other Party, or otherwise act on behalf of the other. Each Party shall be
            solely responsible for payment of the salaries of its employees and
            personnel (including withholding of income taxes and social security),
            worker's compensation, and all other employment benefits.
            <p></p>
        </li>
        <li>
            <strong>Force Majeure.</strong> Neither Party shall be liable hereunder for any failure or
            delay in the performance of its obligations under this Agreement, except for
            the payment of money, if such failure or delay is on account of causes
            beyond its reasonable control, including civil commotion, war, fires,
            floods, accident, earthquakes, inclement weather, telecommunications line
            failures, electrical outages, network failures, governmental regulations or
            controls, casualty, strikes or labor disputes, terrorism, acts of God,
            pandemics, or other similar or different occurrences beyond the reasonable
            control of the Party so defaulting or delaying in the performance of this
            Agreement, for so long as such force majeure event is in effect. The party
            whose performance is impacted by such occurrence (the "Impacted Party ")
            shall give notice within five (5) days of the occurrence to the other party,
            stating the period of time the occurrence is expected to continue. The
            Impacted Party shall use diligent efforts to end the failure or delay and
            ensure the effects of such occurrence are minimized. The Impacted Party
            shall resume the performance of its obligations as soon as reasonably
            practicable after the removal of the cause.
            <p></p>
        </li>
        <li>
            <strong>Governing Law and Venue.</strong> This Agreement will be governed by and interpreted
            in accordance with the laws of the State of Texas, without giving effect to
            the principles of conflicts of law of such state. The Parties hereby agree
            that any action arising out of this Agreement will be brought solely in
            Dallas, Texas.
            <p></p>
        </li>
        <li>
            <strong>Arbitration.</strong> With the exception of (i) claims by MyWorkplace to collect an
            amount due for providing the Services and (ii) proceedings before
            administrative law tribunals ( e.g. , inter partes review before the Patent
            Trial and Appeal Board), any dispute, controversy or claim arising out of or
            related in any manner to this Agreement which cannot be amicably resolved by
            the Parties shall be solely and finally settled by arbitration administered
            by the American Arbitration Association in accordance with its commercial
            arbitration rules. Judgment on the award rendered by the arbitrator(s) may
            be entered in any court having jurisdiction thereof in Dallas, Texas. The
            arbitration shall take place before a panel of one (1) arbitrator sitting in
            Dallas, Texas. The language of the arbitration shall be English. The
            arbitrator will be bound to adjudicate all disputes in accordance with the
            laws of the State of Texas. The decision of the arbitrator shall be in
            writing with written findings of fact and shall be final and binding on the
            Parties. Each Party shall bear its own costs relating to the arbitration
            proceedings irrespective of its outcome. Any claim shall be brought
            individually on behalf of the person or entity seeking relief, not on behalf
            of a class or other persons or entities not participating in the
            arbitration, and shall not be consolidated with the claim of any person who
            is not asserting a claim arising under or relating to this contract. This
            section provides the sole recourse for the settlement of any disputes
            arising out of, in connection with, or related to this Agreement, except
            that a Party may seek a preliminary injunction or other injunctive relief in
            any court of competent jurisdiction in Dallas, Texas if in its reasonable
            judgment such action is necessary to avoid irreparable harm. The arbitrator
            will make the initial determination as to whether any claim is subject to
            arbitration. Notwithstanding any language to the contrary in this Agreement,
            the parties hereby agree that any award issued by the arbitrator (the
            "<strong>Underlying Award</strong>") may be appealed pursuant to the AAA's Optional
            Appellate Arbitration Rules ("<strong>Appellate Rules</strong>"); that the Underlying Award
            rendered by the arbitrator(s) shall, at a minimum, be a reasoned award; and
            that the Underlying Award shall not be considered final until after the time
            for filing the notice of appeal pursuant to the Appellate Rules has expired.
            Appeals must be initiated within thirty (30) days of receipt of an
            Underlying Award, as defined by Rule A-3 of the Appellate Rules, by filing a
            Notice of Appeal with any AAA office. Following the appeal process the
            decision rendered by the appeal tribunal may be entered in any court having
            jurisdiction thereof.
            <p></p>
        </li>
        <li>
            <strong>Assignment.</strong> Neither party may assign any of its rights or obligations
            hereunder, whether by operation of law or otherwise, without the prior
            written consent of the other party (not to be unreasonably withheld).
            Notwithstanding the foregoing, either party may assign this Agreement in its
            entirety, without consent of the other party, to its Affiliates or in
            connection with a merger, acquisition, corporate reorganization, or sale of
            all or substantially all of its assets not involving a direct competitor of
            the other party. Subject to the foregoing, this Agreement shall bind and
            inure to the benefit of the parties, their respective successors and
            permitted assigns.
            <p></p>
        </li>
        <li>
            <strong>Severability.</strong> If any provision or portion of this Agreement shall be
            rendered by applicable law or held by a court of competent jurisdiction to
            be illegal, invalid, or unenforceable, the remaining provisions or portions
            shall remain in full force and effect.
            <p></p>
        </li>
        <li>
            <strong>Headings; Construction.</strong> The headings/captions appearing in this Agreement
            have been inserted for the purposes of convenience and ready reference, and
            do not purport to and shall not be deemed to define, limit or extend the
            scope or intent of the provisions to which they appertain. This Agreement is
            the result of negotiations between the Parties and their counsel.
            Accordingly, this Agreement shall not be construed more strongly against
            either Party regardless of which Party is more responsible for its
            preparation, and any ambiguity that might exist herein shall not be
            construed against the drafting Party.
            <p></p>
        </li>
        <li>
            <strong>Survival.</strong> Each term and provision of this Agreement that should by its sense
            and context survive any termination or expiration of this Agreement, shall
            so survive regardless of the cause and even if resulting from the material
            breach of either Party to this Agreement.
            <p></p>
        </li>
        <li>
            <strong>Rights Cumulative.</strong> The rights and remedies of the Parties herein provided
            shall be cumulative and not exclusive of any rights or remedies provided by
            law or equity.
            <p></p>
        </li>
        <li>
            <strong>Counterparts.</strong> This Agreement may be executed in one or more counterparts,
            each of which will be deemed to be an original, but all of which together
            will constitute one and the same instrument, without necessity of production
            of the others. An executed signature page delivered via facsimile
            transmission or electronic signature shall be deemed as effective as an
            original executed signature page.
            <p></p>
        </li>
        <li>
            <strong>Authorized Signatories.</strong> It is agreed and warranted by the Parties that the
            individuals singing this Agreement on behalf of the respective Parties are
            authorized to execute such an agreement. No further proof of authorization
            shall be required.
            <p></p>
        </li>
        <li>
            <strong>Waiver.</strong> No waiver of any term or right in this Agreement shall be effective
            unless in writing, signed by an authorized representative of the waiving
            Party. The failure of either Party to enforce any provision of this
            Agreement shall not be construed as a waiver or modification of such
            provision, or impairment of its right to enforce such provision or any other
            provision of this Agreement thereafter.
            <p></p>
        </li>
        <li>
            <strong>Entire Agreement; Modification.</strong> This Agreement shall be the entire Agreement
            between the Parties with respect to the subject matter hereof and supersedes
            any prior agreement or communications between the Parties, whether written,
            oral, electronic or otherwise. No change, modification, amendment, or
            addition of or to this Agreement or any part thereof shall be valid unless
            in writing and signed by authorized representatives of the Parties. Each
            Party hereto has received independent legal advice regarding this Agreement
            and their respective rights and obligations set forth herein. The Parties
            acknowledge and agree that they are not relying upon any representations or
            statements made by the other Party or the other Party's employees, agents,
            representatives or attorneys regarding this Agreement, except to the extent
            such representations are expressly set forth in this Agreement.
        </li>
    </ol>
    `;

export const DataProcessingAddendumTitleJsonKey = 'dataProcessingAddendum';
export const DataProcessingAddendumTitle = 'Data Processing Addendum';

export const DataProcessingAddendumTextJsonKey = 'DataProcessingAddendumText';
export const DataProcessingAddendumText = `    <p>This Data Processing Addendum ("<strong>DPA</strong>") is entered into between the Client and MyWorkplace
        to the extent it is incorporated into an Agreement or the Terms between you and MyWorkplace.
        Capitalized words in this DPA shall have the same definition as in the Agreement or the Terms
        unless otherwise defined herein. This DPA shall control in the event of a conflict with the Terms
        or the Agreement.
    </p>
    <ol>
        <li><strong>Definitions:</strong>
            <ol type="a">
                <li>"<strong>Client Data</strong>" shall mean Client's Confidential Information and Personal Information.</li>
                <li>"<strong>Confidential Information</strong>" shall mean any non-public information of one party received
                    by the other party that is designated as confidential or proprietary, that the receiving party
                    knew or reasonably should have known was confidential or proprietary, or that derives
                    independent value from not being generally known to the public. Without limiting the
                    generality of the foregoing, Client's Confidential Information shall include Personal
                    Information, and information regarding Client, its customers, sales, marketing, financial
                    information, personnel matters, or means of doing business and projections and marketing
                    strategy; MyWorkplace's Confidential Information shall include its proprietary
                    methodologies and software codes. The confidentiality obligations hereunder will not
                    extend to information that: (i) already known by or available to the receiving party without
                    obligation of confidentiality prior to disclosure under this Agreement; (ii) is or becomes
                    publicly known without breach by the receiving party; (iii) is rightfully received by the
                    receiving party from a third party without a duty of confidentiality; (iv) is independently
                    developed or learned by the receiving party without use of the disclosing Party's
                    Confidential Information; (v) is disclosed by the receiving party with the disclosing party's
                    prior written approval. (vi) is required to be disclosed pursuant to a lawful order of a
                    governmental authority, so long as the Party required to disclose the information provides
                    the Party owning Confidential Information with timely prior notice of such requirement.</li>
                <li>"<strong>Personal Information</strong>" information that is linked or reasonably linkable to an identified
                    or identifiable individual that is designated by any applicable law or regulation as "personal
                    information" or "personal data" or similar as to any individual who is an employee, officer,
                    agent, shareholder, director or customer of Client.</li>
                <li>"<strong>Security Breach</strong>" - any actual, probable or reasonably suspected unauthorized access to,
                    or acquisition, use, loss, destruction, compromise or disclosure of, any Client Data, while
                    such information is or was in the possession or control of MyWorkplace or its
                    subprocessors.</li>
            </ol>
            <p></p>
        </li>
        <li><strong>Processing of Personal Information</strong>
            <ol type="a">
                <li>
                    The processing of any Personal Information by MyWorkplace pursuant to this Agreement
                    shall be: (i) done in accordance with all applicable laws and regulations and solely pursuant to
                    the instructions of Client, (ii) any such personal information shall be treated as Confidential
                    Information and processed as set forth in this Section, (iii) MyWorkplace shall make available
                    to Client, on reasonable request, all information in MyWorkplace's possession necessary to
                    demonstrate its compliance with the requirements of this Section or applicable law or
                    regulations, (iv) MyWorkplace shall allow, and cooperate with, reasonable data privacy
                    assessments by Client or the Client's designated assessor to the extent required by applicable
                    law or regulation, (v) MyWorkplace shall engage any subcontractor pursuant to a written
                    contract that requires the subcontractor to meet the requirements of MyWorkplace with respect
                    to the applicable Personal Information.</li>
            </ol>
            <p></p>
        </li>
        <li><strong>Responsibility for Data Security.</strong>
            <ol type="a">
                <li>MyWorkplace shall implement and maintain appropriate information and cyber security
                    safeguards ("Safeguards") that prevent the unauthorized access or loss of Client Data,
                    including, without limitation, an information security program that meets the standards of
                    best industry practice to safeguard Personal Information. In addition, MyWorkplace shall
                    store and maintain access to security-related log information from systems, network
                    devices, security solutions, etc. for not less than six (6) months.</li>
                <li>MyWorkplace agrees to store all Client Data in backup data as part of its designated backup
                    and recovery processes in encrypted form, using a commercially supported encryption
                    solution. MyWorkplace further agrees that any and all Client Data stored on any portable
                    or laptop computing device or any portable storage medium be likewise encrypted.
                    Encryption solutions will be deployed with no less than a 128-bit key for symmetric
                    encryption and a 1024 (or larger) bit key length for asymmetric encryption.</li>
                <li>MyWorkplace further agrees that it shall:
                    <ol type="i">
                        <li>Ensure completion of an annual third-party examination of the design and operating
                            effectiveness of MyWorkplace's controls by a reputable certified public accounting
                            firm in accordance with the Statement on Standards for Attestation Engagements No.
                            16 (SSAE 16) and shall obtain a SSAE 16 Service Organization Control (SOC) 2 report.</li>
                        <li>At Client's request, Deliver to Client a full and complete electronic copy of such (SOC)
                            2 report with an effective date no later than September 30 of each year.</li>
                        <li> At Client's request, prepare and deliver to Client a detailed plan for remediating all
                            identified deficiencies and a description of mitigating controls, if applicable, within a
                            reasonable period of time following identification of deficiencies based on the nature
                            and complexity of the deficiencies to be remediated, not to exceed thirty days following
                            identification of such deficiencies; and</li>
                        <li>Bear all costs and expenses associated with correcting deficiencies.</li>
                    </ol>
                </li>
            </ol>
            <p></p>
        </li>
        <li><strong>Audit Requirements.</strong>
            <ol type="a">
                <li>Client or an appointed audit firm ("Auditors") shall, once per calendar year at its own costs,
                    have the right to audit the physical and technical environment of MyWorkplace and any
                    applicable subprocessors as it relates to the receipt, maintenance, use, or retention of Client
                    Data, subject to agreement of a standard confidentiality agreement by said Auditors. Client
                    will announce its intent to audit MyWorkplace by providing at a minimum two weeks (10
                    business days) notice to MyWorkplace. A scope document along with a request for
                    deliverables will be provided at the time of notification of an audit. If the documentation
                    requested cannot be removed from the MyWorkplace's premises, MyWorkplace will allow
                    the Auditors access to its site.</li>
                <li>If an adverse opinion on the design and operating effectiveness of MyWorkplace's internal
                    controls is rendered by the independent certified public accounting firm, Client shall, at its
                    option, have the right to terminate the Agreement without additional cost to Client.</li>
            </ol>
            <p></p>
        </li>
        <li><strong>Notification.</strong> MyWorkplace shall immediately notify Client of any actual, probable or
            reasonably suspected Security Breach with respect to Client Data. Immediate notification shall
            mean as soon as reasonably possible following MyWorkplace's learning of a Security Breach.
            <p></p>
        </li>
        <li><strong>Investigation.</strong>
            <ol type="a">
                <li>MyWorkplace shall (i) assist Client in investigating, remedying and taking any other action
                    Client deems necessary regarding any Security Breach and any dispute, inquiry or claim
                    that concerns the Security Breach; and (ii) shall provide Client with assurance satisfactory
                    to Client that such Security Breach or potential Security Breach will not recur. Unless
                    prohibited by an applicable statute or court order, MyWorkplace shall also notify Client of
                    any third-party legal process relating to any Security Breach, including, but not limited to,
                    any legal process initiated by any governmental entity (foreign or domestic).</li>
                <li>Client may retain a computer forensics firm to conduct a subsequent investigation if the
                    Client in good faith believes that MyWorkplace did not complete a thorough investigation.
                    Client and any government investigative body and such forensic firm shall be given
                    reasonable access to MyWorkplace's systems and logs with full right to make copies of all
                    such logs which may reasonably relate to the Security Breach. Client and the forensic firms
                    shall enter into a confidentiality agreement with MyWorkplace with respect to any such
                    information derived from MyWorkplace's records and systems.</li>
            </ol>
            <p></p>
        </li>
        <li><strong>Breach Notification.</strong>
            <ol type="a">
                <li>MyWorkplace agrees to comply with all applicable laws that require the notification of
                    individuals in the event of unauthorized release of personally identifiable information or
                    other event requiring notification.</li>
                <li>MyWorkplace agrees to assume responsibility for informing all such individuals in
                    accordance with applicable law; provided however, that no press release which includes a
                    reference to Client, notification to any Client Related Party or public pronouncement which
                    includes a reference to Client shall be made without Client's prior approval not to be
                    unreasonably withheld or delayed.</li>
            </ol>
            <p></p>
        </li>
        <li><strong>Agreement Termination.</strong> Upon written request by Client, MyWorkplace will promptly
            return or destroy the Client Data, provided that MyWorkplace shall have the right, subject to the
            requirements of this Agreement, to retain the Client Data to the extent necessary to comply with
            applicable laws. If so requested by Client, MyWorkplace shall promptly certify to Client that it
            has complied with this section. If the Client Data is destroyed, at a minimum, a "Clear" media
            sanitization is to be performed according to the standards enumerated by the National Institute of
            Standards, Guidelines for Media Sanitization, SP800-88.</li>
    </ol>`;
